import request from '@/utils/request'
// 登录
// export function login(username, password) {
//   return request({
//     url: 'Shop.User/login',
//     // url: '/admin/login',
//     method: 'post',
//     data: {
//       username,
//       password
//     }
//   })
// }

// 登录
export function login(username, password) {
  return request({
    url: 'Shop.User/senlogs',
    method: 'post',
    data: {
      username,
      password
    }
  })
}
// 验证码
export function sendSms(data) {
  return request({
    url: 'Shop.User/sendSms',
    method: 'post',
    data: data
  })
}


export function getInfo() {
  return request({
    url: 'Shop.User/info',
    method: 'get',
  })
}

export function logout() {
  return request({
    url: 'Shop.User/logout',
    method: 'post'
  })
}
// 个人中心列表
export function fetchList(params) {
  return request({
    url: 'Shop.User/index',
    method: 'get',
    params: params
  })
}
// 添加
export function createAdmin(data) {
  return request({
    url: 'Shop.User/add',
    method: 'post',
    data: data
  })
}
// 修改
export function updateAdmin(data) {
  return request({
    url: 'Shop.User/son_account',
    method: 'post',
    data: data
  })
}

// 删除
export function deleteAdmin(data) {
  return request({
    url: 'Shop.User/delete',
    method: 'post',
    data: data
  })
}

// 编辑资料
export function update( data) {
  return request({
    url: 'Shop.User/update',
    method: 'post',
    data: data
  })
}
// 验证密码
export function checkpassword(data) {
  return request({
    url: 'Shop.User/checkpassword',
    method: 'post',
    data: data
  })
}
// 修改密码
export function updatePassword(data) {
  return request({
    url: 'Shop.User/updatePassword',
    method: 'post',
    data: data
  })
}
// 上传图片
export function uploadpicture(data) {
  return request({
    url: 'Shop.User/uploadpicture',
    method: 'post',
    data: data
  })
}

// 采购统计年度进货额退货额比例
export function purYearBuyBack(params) {
  return request({
    url: 'Shop.Report/pur_year_buy_back',
    method: 'get',
    params: params
  })
}
// 采购年度进货产品分类分析
export function purYearBuypdtype(params) {
  return request({
    url: 'Shop.Report/pur_year_pdtype',
    method: 'get',
    params: params
  })
}
// 采购年度进货按月统计
export function purYearBuyMonth(params) {
  return request({
    url: 'Shop.Report/pur_year_buy_month',
    method: 'get',
    params: params
  })
}
// 采购前100的产品
export function purYearBuyYearTop(params) {
  return request({
    url: 'Shop.Report/pur_year_top',
    method: 'get',
    params: params
  })
}
// 采购未拿货产品统计
export function purNoBuy(params) {
  return request({
    url: 'Shop.Report/pur_no_buy',
    method: 'get',
    params: params
  })
}


// 记事本列表
export function NotebookList(params) {
  return request({
    url: 'Shop.Notebook/index',
    method: 'get',
    params: params
  })
}
// 添加记事本
export function addNotebook(params) {
  return request({
    url: 'Shop.Notebook/add',
    method: 'get',
    params: params
  })
}
// 回复记事本
export function updateNotebook(params) {
  return request({
    url: 'Shop.Notebook/update',
    method: 'get',
    params: params
  })
}
// 删除记事本
export function deleteNotebook(data) {
  return request({
    url: 'Shop.Notebook/delete',
    method: 'post',
    data: data
  })
}
// 编辑记事本
export function editNotebook(params) {
  return request({
    url: 'Shop.Notebook/edit',
    method: 'get',
    params: params
  })
}

// 微信支付开通市场价格权限
export function wepayfor_marketprice(params) {
  return request({
    url: 'Shop.Accessories/wepayfor_marketprice',
    method: 'get',
    params: params
  })
}
// 查询支付订单状态
export function querypo(data) {
  return request({
    url: 'Pay.WxPay/querypo',
    method: 'post',
    data: data
  })
}
// 首页弹窗 是否不再提醒
export function setPopup(params) {
  return request({
    url: 'Shop.User/popup',
    method: 'get',
    params: params
  })
}

//  获取消息
export function getmsgList(params) {
  return request({
    url: 'Shop.Announcement/getList',
    method: 'get',
    params: params
  })
}
//  获取消息
export function getmsgDetail(params) {
  return request({
    url: 'Shop.Announcement/getDetail',
    method: 'get',
    params: params
  })
}
//  获取未读消息个数
export function getMsgCount(params) {
  return request({
    url: 'Shop.Announcement/getCount',
    method: 'get',
    params: params
  })
}
//  添加反馈
export function addFeedback(data) {
  return request({
    url: 'Shop.Feedback/add',
    method: 'post',
    data: data
  })
}
//  反馈图片上传
export function feedbackuploadPic(data) {
  return request({
    url: 'Tools.Upload/uploadPic',
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js